export default __webpack_public_path__ + "static/transferResults-c213490e56f520ee2dd698b4b25be00a.jpg";